/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Show/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'
import TysiaVisibilityOff from 'DesignSystem/Svgs/TysiaVisibilityOff/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Show({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/PatientOptions/New/Ssn/Show",
  isInvalid,
  onChange
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let appointmentOverlayPatientNewPersonSsnValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'patient_new.person.ssn',
})
let appointmentOverlayPatientNewPersonSsnIsValidData = fromData.useDataIsValid({ viewPath,
context: 'appointment_overlay',
path: 'patient_new.person.ssn',
validate: fromValidate.social_security_number,
})
let appointmentOverlayPatientNewPersonSsnChangeData = fromData.useDataChange({ viewPath,
context: 'appointment_overlay',
path: 'patient_new.person.ssn',
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<div
  data-testid="Show.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={0}
 type="text"
 size="small"
 data="appointment_overlay.patient_new.person.ssn"
 validate="/Data/validate.js social_security_number"
 invalid={!appointmentOverlayPatientNewPersonSsnIsValidData}
 value={appointmentOverlayPatientNewPersonSsnValueData}
 onChange={appointmentOverlayPatientNewPersonSsnChangeData}
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<React.Fragment>
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 mask="ssn"
 placeholder="SSN"
/>
<button
  data-testid="Show.Vertical:1"
  data-view-path={viewPath}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../Hide'))}
 {...isHoveredBind}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaVisibilityOff
  viewPath={`${viewPath}/TysiaVisibilityOff`}
 width={13}
 height={13}
 fill2={dtColorsNeutral400}
/>
</button>
</React.Fragment>
)}
</TysiaInputContent>
)}
</TysiaInput>
</div>
{children}
</React.Fragment>)
}